import { render } from "./GameTemplate.vue?vue&type=template&id=9d54fcaa&scoped=true"
import script from "./GameTemplate.vue?vue&type=script&lang=js"
export * from "./GameTemplate.vue?vue&type=script&lang=js"

import "./GameTemplate.vue?vue&type=style&index=0&id=9d54fcaa&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d54fcaa"]])

export default __exports__